import { resourceExplorerDataSelector } from "./resourceExplorerDataSelector";
import { RootState } from "../../../../store";
import { ResourceExplorerGroupingNullable } from "../../../../../services/cloudchipr.api";
import { resourceExplorerPossibleGroupingsSelector } from "../../possible-groupings/resourceExplorerPossibleGroupingsSelector";

export const resourceExplorerGroupingSelector = (
  state: RootState,
): ResourceExplorerGroupingNullable => {
  const data = resourceExplorerDataSelector(state);
  const possibleGroupings = resourceExplorerPossibleGroupingsSelector(state);

  if (!possibleGroupings) {
    return null;
  }
  const validGroupingValue = possibleGroupings?.some(
    (item) => item.key === data?.grouping,
  );

  if (data?.grouping && !validGroupingValue) {
    return "none";
  }

  return data?.grouping ?? null;
};
